import styled from "styled-components";

export const Instruction = styled.div`
  font-size: 18px;
  padding: 1%;

  input {
    margin-left: 7px;
    width: 20px;
    height: 20px;
    padding: 8px;
    border-radius: 4px;
    position: relative;
    z-index: 2;
  }
`;
